import React from "react"
import { Route, Routes } from "react-router-dom"
import { AggregadorCategory } from '../pages/Agregador/AggregadorCategory'
import { AggregadorCategoryCreate } from '../pages/Agregador/AggregadorCategory/create'
import { AggregadorCategoryEditar } from '../pages/Agregador/AggregadorCategory/editar'
import { AggregadorSubCategory } from '../pages/Agregador/AggregadorCategory/AggregadorSubCategory/index'
import { AggregadorSubCategoryCreate } from '../pages/Agregador/AggregadorCategory/AggregadorSubCategory/create'
import { AggregadorSubCategoryEditar } from '../pages/Agregador/AggregadorCategory/AggregadorSubCategory/editar'
import { DinamicPageCriar } from "../pages/Agregador/dinamicPage/criar"
import { DinamicPageEditar } from "../pages/Agregador/dinamicPage/editar"
import { DinamicPage } from "../pages/Agregador/dinamicPage"
import { AggregadorHighLightIndex } from "../pages/Agregador/publicidadeHighLight"
import { AgregadorPublicityHighLightsCriar } from "../pages/Agregador/publicidadeHighLight/criar"
import { AgregadorPublicityHighLightsEditar } from "../pages/Agregador/publicidadeHighLight/editar"
import { AggregadorBannerIndex } from "../pages/Agregador/publicidade"
import { AgregadorPublicityBannerCriar } from "../pages/Agregador/publicidade/create"
import { AgregadorPublicityBannerEditar } from "../pages/Agregador/publicidade/update"

const AgregadorPrivateRoute = () => {

    return (
        <Routes>
            {/* Rota Categoria */}
            <Route path='/category'>
                <Route path='' element={<AggregadorCategory />} />
                <Route path='create' element={<AggregadorCategoryCreate />} />
                <Route path='editar/:id' element={<AggregadorCategoryEditar />} />
            </Route>
            {/* Rota Subcategoria */}
            <Route path='/subcategory'>
                <Route path='' element={<AggregadorSubCategory />} />
                <Route path='create' element={<AggregadorSubCategoryCreate />} />
                <Route path='editar/:id' element={<AggregadorSubCategoryEditar />} />
            </Route>
            {/* Rota Publicidade */}
            <Route path='/publicidade'>
                <Route path='' element={<AggregadorBannerIndex />} />
                <Route path='create' element={<AgregadorPublicityBannerCriar />} />
                <Route path='editar/:id' element={<AgregadorPublicityBannerEditar />} />
            </Route>

             <Route path='/publicidade-highlights'>
                <Route path='' element={<AggregadorHighLightIndex />} />
                <Route path='create' element={<AgregadorPublicityHighLightsCriar />} />
                <Route path='editar/:id' element={<AgregadorPublicityHighLightsEditar />} />
            </Route>
            {/* Rota Pagina Dinamica Agregador */}
              <Route path='/dinamyc_pages'>
                <Route path='' element={<DinamicPage />} />
                <Route path='create' element={<DinamicPageCriar />} />
                <Route path='editar/:id' element={<DinamicPageEditar />} />
            </Route>

            {/* Rota Pagina Dinamica Agregador */}

        </Routes>
    )
}

export { AgregadorPrivateRoute }